import { render, staticRenderFns } from "./ComplianceStatusExplanation.vue?vue&type=template&id=24400c50&scoped=true&"
import script from "./ComplianceStatusExplanation.vue?vue&type=script&lang=js&"
export * from "./ComplianceStatusExplanation.vue?vue&type=script&lang=js&"
import style0 from "./ComplianceStatusExplanation.vue?vue&type=style&index=0&id=24400c50&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24400c50",
  null
  
)

export default component.exports